





















import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
@Component({})
export default class ProjectSetting extends Vue {
  @Prop()
  private visible: any;
  @Prop()
  private projectId: any;
  @Prop()
  private project: any;
  private projectChange() {
    this.$emit("update:project", this.project);
  }
  private get ifVisible() {
    return this.visible;
  }
  private set ifVisible(val) {
    this.$emit("update:visible", val);
  }
  /**
   * @description 锁定
   */
  private get ifLocked() {
    return this.project["状态"] === "进行中" ? false : true;
  }
  private set ifLocked(val) {
    const params: any = {
      project_id: this.project.project_id,
      action: val ? "锁定" : "进行"
    };
    axios.post("api/project/status", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("设置成功");
        this.$emit("change");
      });
    });
  }
  /**
   * @description 跳转项目基本信息
   */
  private goToBaseInfo() {
    this.$router.push("/main/project/project-create-first/" + this.projectId);
  }
  /**
   * @description 跳转项目分组
   */
  private goToFenzu() {
    this.$router.push("/main/project/project-create-second/" + this.projectId);
  }
  /**
   * @description 跳转项目指标
   */
  private goToFangshi() {
    this.$router.push("/main/project/project-create-third/" + this.projectId);
  }
  /**
   * @description 跳转成员管理
   */
  private goToMemberManage() {
    this.$router.push("/main/project/member-manage/" + this.projectId);
  }
  /**
   * @description 跳转分中心管理
   */
  private goToHospitalManage() {
    this.$router.push("/main/project/hospital-manage/" + this.projectId);
  }
}
